import { render, staticRenderFns } from "./CustomerForm.vue?vue&type=template&id=eb728282"
import script from "./CustomerForm.vue?vue&type=script&lang=js"
export * from "./CustomerForm.vue?vue&type=script&lang=js"
import style0 from "./CustomerForm.vue?vue&type=style&index=0&id=eb728282&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports